import { FC, PropsWithChildren } from 'react';

import useChannelsQuery from '@hooks/queryHooks/useChannelsQuery';
import useProvidersQueries from '@hooks/queryHooks/useProvidersQueries';
import { TMenuItemPreview, TPageSectionItemPreview } from '@models/LayoutPreview';
import { getEditorialImgUrl } from '@utils/imageUtils';

import SourceIconContext, { SourceIcon, SourceIconValues } from './context';

const SourceIconProvider: FC<PropsWithChildren> = ({ children }) => {
  const { data: providers } = useProvidersQueries();
  const { data: channels } = useChannelsQuery();

  const getProviderIconUrl = (providerIdentifier: string) => {
    const provider = providers?.find(({ id }) => id === providerIdentifier);
    if (provider) return getEditorialImgUrl(provider.image, 'square', { width: 60 });
    return;
  };

  const getSourceIcon = (
    item: TMenuItemPreview | TPageSectionItemPreview,
    displayProviderIcon?: boolean
  ): SourceIcon | undefined => {
    const providerIdentifier = item.title?.providers?.[0];

    if (!displayProviderIcon) return;
    if (!providerIdentifier) return;
    if (channels?.data.find(({ value: { id } }) => id === providerIdentifier))
      return { icon: 'tv' };

    const providerIconUrl = getProviderIconUrl(providerIdentifier);
    if (providerIconUrl) return { url: providerIconUrl };
    return;
  };

  const values: SourceIconValues = { getSourceIcon };

  return <SourceIconContext.Provider value={values}>{children}</SourceIconContext.Provider>;
};

export default SourceIconProvider;
